// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"RefinementSalesOffersDropdown_disclaimer__ajr_D","allRow":"RefinementSalesOffersDropdown_allRow__NLAfU","allCount":"RefinementSalesOffersDropdown_allCount__y095y"};